<template>
  <span v-if="enabled" ref="film-viewed-indicator" class="film-viewed-indicator">{{'\u{2022}'}}</span>
</template>


<script>
import { userStore } from "@/userStore";
import {EventBus} from "@/eventBus";

export default {
  name: "FilmReviewedIndicator",
  props: ['film_id', 'debug_film_name'],
  data() {
    return {
      enabled: !this.$screenshotMode && !userStore.hasReviewedFilm(this.film_id),
      intersectionObserver: null,
    }
  },
  created() {
    if ( this.enabled ) {
      EventBus.on('film-reviewed', this.onFilmReviewedEvent);
    }
  },
  mounted() {
    if ( this.enabled ) {
      if ( this.isIndicatorVisible() ) {
        // if the indicator just starts out visible, mark the film as viewed now
        this.markFilmReviewed();

      } else {
        // if the indicator doesn't start out visible, add an observer so we know if it becomes visible
        this.intersectionObserver = new IntersectionObserver(this.onIntersection);
        this.intersectionObserver.observe(this.$refs['film-viewed-indicator']);
      }
    }
  },

  beforeUnmount() {
    if ( this.enabled ) {
      this.intersectionObserver?.disconnect();
      EventBus.off('film-reviewed', this.onFilmReviewedEvent);
    }
  },

  methods: {
    onFilmReviewedEvent(_film_id) {
        if (this.film_id === _film_id) {
          this.$refs['film-viewed-indicator']?.classList.add('hidden');
      }
    },

    isIndicatorVisible() {
      if ( !this.enabled ) {
        return false;
      }

      // is the indicator visible
      const rect = this.$refs['film-viewed-indicator'].getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    onIntersection(_entries) {

      const entry = _entries[0];
      if ( entry?.isIntersecting ) {
        this.markFilmReviewed();
      }
    },

    markFilmReviewed() {
      userStore.markFilmReviewed(this.film_id);
    }
  }
}
</script>


<style scoped>
.film-viewed-indicator {
  color: var(--mol-color-gold);
  vertical-align: super;

  &.hidden {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 2s, opacity 2s linear;
  }
}

</style>